<div class="change-user-password-dialog">
  <nb-card accent="primary">
    <nb-card-header>{{ mode === 'own' ? 'Passwort ändern' : 'Passwort zurücksetzen' }}</nb-card-header>
    <nb-card-body>
      @if (serverError()) {
        <nb-alert status="danger" closable (close)="serverError.set('')">{{ serverError() }}</nb-alert>
      }
      <form [formGroup]="form">
        @if (mode === 'own') {
          <div class="form-field">
            <label class="label" for="currentPassword">Aktuelles Passwort</label>
            <input nbInput fullWidth id="currentPassword" type="password" formControlName="currentPassword"
                   placeholder="Aktuelles Passwort eingeben">
          </div>
        }
        <div class="form-field">
          <label class="label" for="newPassword">Neues Passwort</label>
          <input nbInput fullWidth id="newPassword" type="password" formControlName="newPassword"
                 placeholder="Neues Passwort eingeben" [status]="form.controls['newPassword'].touched && form.controls['newPassword'].hasError('minlength') ? 'danger' : 'basic'">
          @if (form.controls['newPassword'].touched && form.controls['newPassword'].hasError('minlength')) {
            <span class="validation-hint">Mindestens 8 Zeichen</span>
          }
        </div>
        <div class="form-field">
          <label class="label" for="repeatPassword">Passwort bestätigen</label>
          <input nbInput fullWidth id="repeatPassword" type="password" formControlName="repeatPassword"
                 placeholder="Neues Passwort bestätigen">
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton status="basic" (click)="cancel()">Abbrechen</button>
      <button nbButton status="primary"
              [disabled]="form.invalid || submitting()"
              [nbSpinner]="submitting()"
              (click)="submit()">
        {{ mode === 'own' ? 'Passwort ändern' : 'Passwort zurücksetzen' }}
      </button>
    </nb-card-footer>
  </nb-card>
</div>
